<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <v-switch
              v-model="enable_auth_section"
              label="Habilitar registro asistentes/login"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-divider></v-divider>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h3>Tarjeta de Asistente:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12" class="mt-4">
            <v-slider
              :disabled="!enable_auth_section"
              v-model="height_assistant_card"
              max="800"
              min="100"
              label="Altura tarjeta"
              thumb-label="always"
            ></v-slider>

            <vue-editor
              v-if="true"
              :disabled="!enable_auth_section"
              :editor-toolbar="customToolbar"
              v-model="text_assistant_card" 
              @input="checkContentLengthAssistant">
            </vue-editor>
            <div v-if="true">{{ remainingCharactersAssistants }} caracteres restantes.</div>
          
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-card
              class="mx-auto"
              max-width="340"
              outlined>
              <v-row :style="{ height: height_assistant_card + 'px' }">
                <v-col cols="12" class="pt-8 text-center">
                  <v-img 
                    :src="require('@/assets/icons/register_icon.png')"
                    height="72"
                    contain
                  />
                </v-col>

                <v-col 
                  cols="12" 
                  class="text-body-1 text-center pl-8 pr-8">
                  <div v-html="text_assistant_card"></div>
                </v-col>
              </v-row>

              <v-divider class="mt-8"></v-divider>

              <v-card-actions>
                <v-btn
                  class="pa-2"
                  block
                  x-large
                  color="error">
                  Registrarme como asistente
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-divider></v-divider>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h3>Tarjeta Login:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12" class="mt-4">
            <v-slider
              :disabled="!enable_auth_section"
              v-model="height_user_card"
              max="800"
              min="100"
              label="Altura tarjeta"
              thumb-label="always"
            ></v-slider>

            <vue-editor
              v-if="true"
              :disabled="!enable_auth_section"
              :editor-toolbar="customToolbar"
              v-model="text_user_card" 
              @input="checkContentLength">
            </vue-editor>
            <div v-if="true">{{ remainingCharactersUser }} caracteres restantes.</div>
          
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-card
              class="mx-auto"
              max-width="340"
              outlined>
              <v-row :style="{ height: height_user_card + 'px' }">
                <v-col cols="12" class="pt-8 text-center">
                  <v-img 
                    :src="require('@/assets/icons/register_icon.png')"
                    height="72"
                    contain
                  />
                </v-col>

                <v-col 
                  cols="12" 
                  class="text-body-1 text-center pl-8 pr-8">
                  <div v-html="text_user_card"></div>
                </v-col>
              </v-row>

              <v-divider class="mt-8"></v-divider>

              <v-card-actions>
                <v-btn
                  class="pa-2"
                  block
                  x-large
                  color="error">
                Iniciar Sesión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col
      cols="12" 
      class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateAuthSection()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  // const APP_URL = process.env.VUE_APP_URL
  import { VueEditor } from "vue2-editor";

  export default {
    name: 'customizationAuthSection',
    components: {
      VueEditor
    },
    data: () => ({
      loading:true,
      loading_update: false,
      landing:[],
      editions: [],

      enable_auth_section: false,

      height_assistant_card:280,
      text_assistant_card:"",

      height_user_card:280,
      text_user_card:"",

      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'indent': '-1'}, { 'indent': '+1' }]
      ],
      
      type_featured_sponsors: 'edition',
      edition_selected_featured_sponsors: null,

      maxLength: 800, // Máximo número de caracteres permitidos

      error:false,
      errors:[]
    }),
    computed: {
      remainingCharactersAssistants() {
        return this.maxLength - this.text_assistant_card.length
      },

      remainingCharactersUser() {
        return this.maxLength - this.text_user_card.length
      }
    },

    methods:{
      checkContentLengthAssistant() {
        if (this.text_assistant_card.length > this.maxLength) {
          this.text_assistant_card = this.text_assistant_card.substring(0, this.maxLength);
        }
      },
      
      checkContentLength() {
        if (this.text_assistant_card.length > this.maxLength) {
          this.text_assistant_card = this.text_assistant_card.substring(0, this.maxLength);
        }
      },
      
      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing

          this.enable_auth_section    = (this.landing.enable_auth_section==1)?true:false
          this.height_assistant_card  = this.landing.height_assistant_card
          this.text_assistant_card    = (this.landing.text_assistant_card!=null)?this.landing.text_assistant_card:''
          this.height_user_card       = this.landing.height_user_card
          this.text_user_card         = (this.landing.text_user_card!=null)?this.landing.text_user_card:''

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateAuthSection(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('enable_auth_section', (this.enable_auth_section)?1:0)
        formData.append('height_assistant_card', this.height_assistant_card)
        formData.append('text_assistant_card', this.text_assistant_card)
        formData.append('height_user_card', this.height_user_card)
        formData.append('text_user_card', this.text_user_card)

        try {
          await axios({
            method: 'post',
            url: 'admin/landing/auth-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_cover_image_main_section = URL.createObjectURL(this.cover_image_main_section);
      },

      deleteProjectImage(){
        this.cover_image_main_section=null
        this.url_cover_image_main_section=null
      }
    },

    created(){
      this.getCustomization()
    },
  }
</script>
